import { TaskStatus, type Task } from "@/api.types.v2";

const TERMINAL = new Set<Task["status"]>([
  TaskStatus.COMPLETED,
  TaskStatus.FAILED,
  TaskStatus.CANCELLED,
]);

export function taskIsOnCancellationHold(
  task: Pick<Task, "shipment" | "cancellationReviewPending" | "workHold">
): boolean {
  return Boolean(
    task.cancellationReviewPending ||
      task.workHold?.active ||
      task.shipment?.cancellationRequestedAt
  );
}

export function unresolvedHoldState(tasks: Task[]) {
  const unresolved = tasks.filter((task) => !TERMINAL.has(task.status));
  const heldCount = unresolved.filter(taskIsOnCancellationHold).length;
  return {
    heldCount,
    allHeld: unresolved.length > 0 && heldCount === unresolved.length,
  };
}
